import { render, staticRenderFns } from "./UploadEntrance.vue?vue&type=template&id=5c1cefe2"
import script from "./UploadEntrance.vue?vue&type=script&lang=js"
export * from "./UploadEntrance.vue?vue&type=script&lang=js"
import style0 from "./UploadEntrance.vue?vue&type=style&index=0&id=5c1cefe2&prod&lang=scss"
import style1 from "./UploadEntrance.vue?vue&type=style&index=1&id=5c1cefe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports